import { AidKitLogo } from '@aidkitorg/component-library';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { get_deployment, useAPI, usePost, useToken } from '../API';
import { PublicConfig } from '@aidkitorg/types/lib/config';
import { SupportedLanguage } from '../Context';

const AIDKIT_LOGO = <AidKitLogo width={100} height={50} />

const ThemeContext = createContext<ThemeContextType>({
  logo: AIDKIT_LOGO,
  languages: ['en', 'es'],
});

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    // TODO: should we throw an error here or just silently fail?
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

type ThemeProviderProps = {
  children: React.ReactNode
}  

type ThemeContextType = {
  logo: React.ReactElement,
  languages: Array<SupportedLanguage>
}

// TODO: make it so that the sizing can be changed

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [logo, setLogo] = useState<React.ReactElement>(AIDKIT_LOGO)
  const [languages, setLanguages] = useState<Array<SupportedLanguage>>(['en', 'es'])
  const [, token] = useToken();

  const getAuthAwareConfig = usePost("/program/public_configuration");
  const getLegacyConfiguration = usePost("/program/legacy_configuration");

  useEffect(() => {
    (async () => {
      const authAwareConfig = await getAuthAwareConfig({})
      if (authAwareConfig.interface?.applicantFacingLogo?.url) {
        const customLogo = <img
          className="w-auto max-w-[150px] max-h-[125px]"
          src={authAwareConfig.interface?.applicantFacingLogo?.url}
          alt={authAwareConfig.name || 'AidKit Program'}
          width={authAwareConfig.interface?.applicantFacingLogo?.width || '150'}
        />
        setLogo(customLogo)
      } 


      const legacyConfig = await getLegacyConfiguration({})
      if (legacyConfig?.languages) {
        const languages = legacyConfig.languages.split(",")
        setLanguages([...languages])
      }

    })()
  }, [token])
	
  const value: ThemeContextType = {
    logo,
    languages
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}